import { render, staticRenderFns } from "./pay25m.vue?vue&type=template&id=4f86e705&scoped=true&"
import script from "./pay25m.vue?vue&type=script&lang=js&"
export * from "./pay25m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f86e705",
  null
  
)

export default component.exports